// Angular
import { Component, NgZone } from '@angular/core';
// AG-Grid
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { SetOrderDocumentManually } from '../../quality/state/actions/quality.actions';

import { Router } from '@angular/router';
import { Store } from '@ngxs/store';

@Component({
	selector: 'cv-custom-status-import-cell',
	templateUrl: './custom-status-cell.component.html',
	styleUrls: ['./custom-status-cell.component.scss']
})
export class CustomStatusImportCellComponent implements ICellRendererAngularComp {
	public cellValue: any;
	public canOpen: boolean;
	public failedMsg: string;
	public isFail: boolean;
	constructor(private ngZone: NgZone, private router: Router, private store: Store) {}

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.value;
	}

	/**
	 * Put back the value
	 * @param params
	 */
	 refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}
}
